import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiCommunityService } from '@services/api-community.service';
import { SharedService } from '@services/shared.service';
import { CommunityCustomerAnswerModel, CommunityCustomerModel, CommunityFormModel, CommunityModel } from '@shared/models/CommunityModel';
import { CustomerModel, CustomerPhoneFindModel } from '@shared/models/CustomerModel';

@Component({
    selector: 'app-community-form',
    templateUrl: './community-form.component.html',
    styleUrls: ['./community-form.component.scss']
})
export class CommunityFormComponent implements OnInit {

    @Input() community: CommunityModel; 
    @Input() customer: CustomerModel = null;

    @Output() onCanAssign: EventEmitter<boolean> = new EventEmitter<boolean>(); 

    communityForm: CommunityFormModel;
    invitationForm: UntypedFormGroup;

    accountForm: UntypedFormGroup;

    isExpanded: boolean = false; // Controla si el texto está expandido o no


    constructor(public route: ActivatedRoute,
        public router: Router,
        public sharedService: SharedService,
        private formBuilder: UntypedFormBuilder,
        public modalService: NgbModal,
        private apiCommunityService: ApiCommunityService,) { }

    ngOnInit(): void {
        this._getCommunityForm();
    }

    toggleView() {
        this.isExpanded = !this.isExpanded; // Alterna entre expandido y truncado
    }

    onSendCommunityRequest() {

        const communityCustomer = new CommunityCustomerModel();
        communityCustomer.communityId = this.community.id;
        communityCustomer.customerId = this.customer.id;
        communityCustomer.customer = this.customer;
        communityCustomer.requestCode = null;

        if (this.communityForm?.id) {

            if (this.invitationForm.invalid) return;

            communityCustomer.communityFormId = this.communityForm.id;
            communityCustomer.form = this.communityForm;

            // Acceder a los valores de los inputs dinámicos
            const communityCustomerAnswerList = this.invitationForm.value.dynamicInputs.map((input, index) => new CommunityCustomerAnswerModel({
                id: this.communityForm.questions[index]?.id,
                communityId: communityCustomer.communityId,
                customerId: communityCustomer.customerId,
                communityFormId: communityCustomer.form.id,
                communityFormQuestionId: this.communityForm.questions[index]?.id,
                answer: input.value,
            }));

            communityCustomer.answers = communityCustomerAnswerList;
        }

        this.sharedService.setLoading(true);

        this.apiCommunityService.postCommunityCustomer(communityCustomer).then(
            (result) => {

                this.sharedService.setLoading(false);

                if(!this.communityForm?.isAutoApproval){

                     // Success complete form
                    this.onCanAssign.emit(false);
                } else{
                    
                    this.onCanAssign.emit(true);
                }

            }).catch((error: any) => {

                this.sharedService.setLoading(false);
                // display error
                const errMsg = this.apiCommunityService.getErrorMsg(error, error?.error?.Message || 'No se pudo enviar el formulario');
                this.sharedService.showErrorAlert(null, errMsg);
            }
            );
    }

    get dynamicInputs() {

        if(this.invitationForm == null) return null;
        return this.invitationForm?.get('dynamicInputs') as UntypedFormArray;
    }

    private _formInvitationInit() {

        this.invitationForm = this.formBuilder.group(
            
            {
                dynamicInputs: this.formBuilder.array([])
            }
        );

        const dynamicInputs = this.dynamicInputs as UntypedFormArray;

        this.communityForm?.questions?.forEach(item => {
            dynamicInputs.push(this.formBuilder.group({
                name: [item.question, Validators.required],
                value: ['', Validators.required]
            }));
        });
    }

    private _getCommunityForm() {

        this.communityForm = this.community?.forms.find(x => x.isMainForm);
        if (!this.communityForm) return;

        // Obtener el formulario default
        this.apiCommunityService.getFullCommunityForm(this.communityForm.id).then(
            (communityForm: CommunityFormModel) => {
                
                this.communityForm = communityForm;
                this._formInvitationInit();

                this.sharedService.setLoading(false);
            }
        );
    }

}
